import { useGetDoclist } from "~/api/chat/chat";
import { NotFound } from "~/components/NotFound";
import { SkyViewTour } from "~/features/onboarding";
import { SkyView } from "~/features/skyView/ui";
import { ROUTES, useChatDocumentParams } from "~/helpers";

export const SkyViewPage = () => {
  const { organizationId, caseId, documentId } = useChatDocumentParams();
  const { isError } = useGetDoclist(
    organizationId,
    caseId,
    documentId ? { documentId } : undefined,
    {
      query: {
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
      },
    }
  );

  if (isError) {
    return <NotFound backRoute={ROUTES.CASES({ organizationId })} />;
  }

  return (
    <>
      <SkyViewTour />
      <SkyView />
    </>
  );
};
